export default __webpack_public_path__ + "static/media/2dcc9b9a-22bd-41dc-ac7a-9e21b0fb5790.314b7145.jpg";